import { readOnly } from '@ember/object/computed';
import Service, { inject as service } from '@ember/service';
import { initializePropertyDefaults } from 'sh-www/utils/initialize-state-properties';

export default Service.extend({
  /**
   * Register Services
   */
  session: service(),
  store: service(),

  currentUser: readOnly('session.currentUser'),

  /**
   * @inheritDoc
   */
  propertyDefaults: {
    /**
     * True if we are loading the payment state.
     *
     * @type {Boolean}
     */
    isLoadingPayment: false,

    /**
     * @type {ShInvoice}
     */
    shPayment: null
  },

  /**
   * @inheritDoc
   */
  init() {
    this._super(...arguments);
    initializePropertyDefaults(this);
  }
});
